<template>
  <div class="grid-x pn flex-align-top">
    <div
      v-for="(item, idx) in columns"
      :key="'col' + (idx + 1)"
      :class="columnCss"
    >
      <slot :name="['col', idx + 1].join('-')"></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Mixins } from "vue-facing-decorator";
import PageElementMixin from "../field-element";
@Component({
  name: "flex-grid",
  mixins: [PageElementMixin]
})
export default class FlexGrid extends Vue {
  get columns(): string[] {
    const slots: string[] = [];

    for (let key in this.$slots) {
      if (key.startsWith("col")) {
        slots.push(key);
      }
    }
    return slots;
  }

  get columnCss(): string[] {
    const max = 12;
    let size = max;
    if (max % this.columns.length === 0) {
      size = max / this.columns.length;
    }
    return ["cell", "medium-" + size];
  }
}
</script>
